import { CursorPoint } from "./style";

const Index = () => {
  return (
    <CursorPoint>
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="15656"
        width="24"
        height="24"
      >
        <path
          d="M169.671331 228.433666c0-23.3805 19.069311-42.339294 42.615587-42.339294l213.026768 0 0-42.285059c0-23.381523 19.069311-42.285059 42.615587-42.285059l85.23322 0c23.546276 0 42.615587 18.959817 42.615587 42.339294l0 42.339294L808.804846 186.202842c23.491017 0 42.615587 18.959817 42.615587 42.340317l0 42.339294L169.671331 270.882454 169.671331 228.433666 169.671331 228.433666zM808.804846 355.343077l0 84.625376 0 437.216783c0 23.3805-19.125593 42.340317-42.617633 42.340317l-511.284709 0c-23.546276 0-42.615587-18.958794-42.615587-42.340317L212.286917 439.968453l0-84.625376L212.286917 313.114301 808.804846 313.114301 808.804846 355.343077 808.804846 355.343077zM382.697075 440.022689c0-23.381523-19.12457-42.339294-42.615587-42.339294-23.491017 0-42.561351 18.958794-42.561351 42.339294l0 352.648712c0 23.325241 19.069311 42.285059 42.615587 42.285059 23.546276 0 42.615587-18.959817 42.615587-42.285059L382.751311 440.022689 382.697075 440.022689 382.697075 440.022689zM553.162492 440.022689c0-23.381523-19.125593-42.339294-42.617633-42.339294-23.546276 0-42.615587 18.958794-42.615587 42.339294l0 352.648712c0 23.325241 19.12457 42.285059 42.615587 42.285059s42.617633-18.959817 42.617633-42.285059L553.162492 440.022689 553.162492 440.022689zM723.571626 440.022689c0-23.381523-19.069311-42.339294-42.615587-42.339294s-42.615587 18.958794-42.615587 42.339294l0 352.648712c0 23.325241 19.12457 42.285059 42.615587 42.285059 23.491017 0 42.615587-18.959817 42.615587-42.285059L723.571626 440.022689 723.571626 440.022689z"
          fill="#1fc7d4"
          p-id="15657"
        ></path>
      </svg>
    </CursorPoint>
  );
};

export default Index; // 默认导出
